export default __webpack_public_path__ + "/dist/images/how-it-work.a2a8cc5540973b1008241871b1796df6.png";